<template>
  <transition name="fade">
    <div v-if="Object.keys(summary).length">
      <div class="section" id="cont">
        <!--  Header  -->
        <section id="views" class="hero title-card">
          <div class="hero-body">
            <div class="container">
              <h1 class="title">
                Resumen del Resultado de CL7 - Clima Laboral
              </h1>
              <h2 class="subtitle" v-if="proceso.processComp">
                Comparado con {{ proceso.processComp.nombre }}
              </h2>
              <!-- <h2 class="subtitle">
              Resumen del Resultado de Factores de riesgos psicosociales
            </h2> -->
            </div>
            <div>
              <span>Fecha de diagnóstico</span>
              <h4 class="has-text-dark">{{ dateProcess(infoProcess.date) }}</h4>
            </div>
          </div>
        </section>

        <!--  Data  -->
        <div class="columns sub-header">
          <div class="column" style="padding-left: 0;">
            <table
              class="is-flex is-justify-start table-radius-6"
              style="width: 100%"
            >
              <tr
                v-tooltip.bottom-start="
                  'Menos del 16% de las personas en alto o muy alto'
                "
              >
                <div class="p-2 bg-muyinconveniente"></div>
                <td class="p-2">Actuemos ya</td>
              </tr>
              <tr
                v-tooltip.bottom-start="
                  'Entre el 16% y el 29.9% de personas en alto o muy alto'
                "
              >
                <div class="p-2 bg-inconveniente"></div>
                <td class="p-2">Necesita atención pronto</td>
              </tr>
              <tr
                v-tooltip.bottom-start="
                  'Entre el 30% y el 69.9% de personas en alto o muy alto'
                "
              >
                <div class="p-2 bg-regular"></div>
                <td class="p-2">Cuidado</td>
              </tr>
              <tr
                v-tooltip.bottom-start="
                  'Entre el 70% y el 83.9% de personas en alto o muy alto'
                "
              >
                <div class="p-2 bg-positivo"></div>
                <td class="p-2">Vamos bien</td>
              </tr>
              <tr
                v-tooltip.bottom-start="
                  'Si el 84% o más de las personas está en los niveles de alto y muy alto'
                "
              >
                <div class="p-2 bg-excelente"></div>
                <td class="p-2">Sigamos así</td>
              </tr>
            </table>
          </div>
          <div
            class="column is-flex is-justify-end"
            style="margin: auto; padding: 0;"
          >
            <a
              v-if="tokenUser && tokenUser.admin & !showSection"
              href="javascript:void(0)"
              class="button is-small is-dark radius-6"
              :disabled="this.validCtx"
              v-on:click="switchContext"
              style="gap: 5px"
            >
              <i class="material-icons">language</i>
              <span
                >{{
                  generalContext.status ? "Ocultar" : "Mostrar"
                }}
                Benchmark</span
              >
            </a>
          </div>
        </div>

        <!-- SubHeader - Cards Info  -->
        <section style="margin-top: 25px">
          <div class="container columns has-text-centered">
            <div class="column is-parent is-vertical">
              <div class="box">
                <h1 class="is-size-5 has-text-weight-bold">Participación</h1>
                <span class="is-size-3 has-text-dark"
                  >{{ infoProcess.participation }}%</span
                >
              </div>
            </div>
            <div class="column is-parent is-vertical">
              <div class="box box-sub">
                <h1 class="is-size-5 sub has-text-weight-bold">Encuestados</h1>
                <span class="is-size-4">{{ infoProcess.totalParti }}</span>
              </div>
            </div>
            <div class="column is-parent is-vertical">
              <div class="box box-sub">
                <h1 class="is-size-5 sub has-text-weight-bold">
                  Encuestas válidas
                </h1>
                <span class="is-size-4">{{ infoProcess.totalPartiEli }}</span>
              </div>
            </div>
            <div class="column is-parent is-vertical">
              <div class="box box-sub">
                <h1 class="is-size-5 sub has-text-weight-bold">Eliminados</h1>
                <span class="is-size-4">{{ infoProcess.inconsistencies }}</span>
              </div>
            </div>
            <!--
          <div class="column is-parent is-vertical">
            <div class="box box-sub">
              <h1 class="is-size-5 sub has-text-weight-bold">Inconsistencias</h1>
              <span class="is-size-4">{{ infoProcess.inconsistencies }}</span>
            </div>
          </div>
          <div class="column is-parent is-vertical">
            <div class="box box-sub">
              <h1 class="is-size-5 sub has-text-weight-bold">Sin Consentimiento</h1>
              <span class="is-size-4">{{ infoProcess.noConsent }}</span>
            </div>
          </div>
          --></div>
        </section>

        <!--  Section Views  -->
        <div id="views">
          <transition name="fade">
            <!--   ResultadosGeneral - ResultadosDetallado   -->
            <component
              ref="content"
              :is="showSection ? 'ResultadosDetallado' : 'ResultadosGeneral'"
              :summaryTotal="this.summary"
              :generalContext="this.generalContext"
              :proceso="this.proceso"
              :processValuesCal="processValuesCal"
              :createdLineContext="createdLineContext"
              :validCtx="this.validCtx"
              @section="section"
              @goToGuie="goToGuie"
              @getPosition="getPosition"
              :showSection="showSection"
              style="margin-top: 20px"
            ></component>
          </transition>
        </div>

        <!--  Button more details and show guia  -->
        <div class="is-flex">
          <div
            v-on:click="section"
            v-if="!showSection"
            class="button is-dark"
            style="margin-top: 25px"
          >
            <span style="margin-right: 5px">{{
              showSection ? "Ver menos Detalles" : "Ver Detalles"
            }}</span>
            <span class="icon"
              ><i class="material-icons is-size-1">{{
                showSection ? "arrow_drop_up" : "arrow_drop_down"
              }}</i></span
            >
          </div>
          <div
            v-on:click="goToGuie"
            v-if="!showSection"
            class="button is-dark"
            style="margin-top: 25px; margin-left: 10px"
          >
            <span style="margin-right: 5px">Ver guía</span>
            <span class="icon"
              ><i class="material-icons">local_library</i></span
            >
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import apiServices from "@/services/yungol-services";
import ResultadosGeneral from "./ResultadosGeneral";
import ResultadosDetallado from "./ResultadosDetallado";
import { mapState } from "vuex";
/* import {gsap} from "gsap"; */

export default {
  data() {
    return {
      summary: {},
      showSection: false,
      infoProcess: {},
      generalContext: {
        status: false,
        data: {},
        headers: {},
      },
    };
  },
  props: {
    proceso: {
      type: Object,
    },
  },
  computed: {
    ...mapState(["empresa", "tokenUser"]),
    validCtx() {
      return (
        this.isEmpty(this.generalContext.data) &&
        this.isEmpty(this.generalContext.headers)
      );
    },
  },
  methods: {
    // Data
    async findSummary() {
      try {
        const result = await apiServices.post(`/traecalculoclima`, {
          filters: [],
          proceso: this.proceso._id,
        });
        if (result.data) {
          if (this.proceso.processComp) {
            const resultComp = await apiServices.post(`/traecalculoclima`, {
              filters: [],
              proceso: this.proceso.processComp._id,
            });
            result.data.calculos.processComp = this.processValuesCal(
              resultComp.data.calculos
            );
            result.data.calculos.processComp.nombre = this.proceso.processComp.nombre;
          }
          this.infoProcess = result.data.infoProcess;
          this.summary = this.processValuesCal(result.data.calculos);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getGeneralContext() {
      try {
        if (this.tokenUser && !this.tokenUser.admin) return;
        const result = await apiServices.get("/cl7/generalContext");
        if (result.data) {
          this.generalContext.data = result.data.context;
          this.generalContext.headers = result.data.headers;
          this.generalContext.headers.position = this.getPosition(
            result.data.headers,
            "CClimad"
          );
        }
      } catch (err) {
        console.log(err);
      }
    },
    // General Context
    createdLineContext(group) {
      if (!group && !Object.keys(this.generalContext.data).length) return null;

      const position = this.summary.total[group].p;
      const context = Object.entries(this.generalContext.data[group]);
      const labels = context.map(([k, v]) => parseInt(k));
      const colors = labels.map((v) => this.getInfoRange(v));

      return {
        type: "line",
        data: {
          datasets: [
            {
              label: "Empresas",
              data: context.map(([k, v]) => {
                return { x: Number(k), y: Number(v) };
              }),
              fill: false,
              color: colors,
              backgroundColor: colors,
              borderColor: "rgb(75, 192, 192)",
              tension: 0.2,
              pointRadius: function(context) {
                const dataIndex = context.dataIndex;
                const dataset = context.dataset.data;

                // if (dataIndex === 0 || dataIndex === dataset.length - 1) {
                //   return 4;
                // }

                const value = dataset[dataIndex].y;
                return value === 0 ? 0 : 4;
              },
            },
          ],
        },
        options: {
          tooltips: {
            callbacks: {
              title: function(tooltipItem, data) {
                const value = tooltipItem[0].label;
                const nextStep = parseInt(value) + 5; // 5 es el stepSize de los ticks en xAxes
                return `${this.getInfoRange(
                  value,
                  "title"
                )} (${value}% al ${nextStep}%)`;
              }.bind(this),
            },
          },
          legend: { display: false, position: "right" },
          responsive: true,
          maintainAspectRatio: false,
          resizeDelay: 0,
          scales: {
            yAxes: [
              {
                ticks: {
                  stepSize: 1,
                  beginAtZero: true,
                  padding: 0,
                },
                gridLines: {
                  display: true,
                },
              },
            ],
            xAxes: [
              {
                type: "linear",
                ticks: {
                  stepSize: 5,
                  min: Math.min(...labels),
                  max: Math.max(...labels),
                  autoSkip: false,
                  display: false,
                },
                gridLines: {
                  display: false,
                },
              },
            ],
          },
          annotation: {
            annotations: [
              {
                id: "a-line-1",
                type: "line",
                mode: "vertical",
                scaleID: "x-axis-0",
                value: position.toFixed(2),
                borderColor: "rgba(0, 0, 0, 0.5)",
                borderWidth: 2,
                labelEnabled: true,
                imagenStatus: false,
                label: {
                  enabled: true,
                  content: ".",
                  position: "top",
                  fontColor: "#FFFFFF",
                  fontSize: 14,
                  fontStyle: "bold",
                  fontFamily: "Arial",
                  backgroundColor: "rgba(0, 0, 0, 0)",
                  xPadding: 10,
                  yPadding: 0,
                  yAdjust: 0,
                  cornerRadius: 5,
                },
              },
            ],
          },
        },
        plugins: [
          {
            beforeDraw: (chart) => {
              const ctx = chart.chart.ctx;

              const xScale = chart.scales["x-axis-0"];
              const yScale = chart.scales["y-axis-0"];

              xScale.ticks.forEach((tick, index) => {
                const tickX = xScale.getPixelForTick(index);
                ctx.fillStyle = this.getInfoRange(tick);
                const tickWidth =
                  index < xScale.ticks.length - 1
                    ? xScale.getPixelForTick(index + 1) - tickX
                    : xScale.right - tickX;

                ctx.fillRect(tickX, yScale.bottom, tickWidth, 20);
              });
            },
            afterDatasetsDraw: (chart) => {
              const ctx = chart.ctx;
              const sizeImg = 30;
              // Recorre las anotaciones y dibuja la imagen
              Object.entries(chart.annotation.elements).forEach(
                ([key, annotation]) => {
                  if (annotation.options.type !== "line") return;

                  const model = annotation._model;

                  if (!model || isNaN(model.x1) || isNaN(model.y1)) return;

                  if (annotation.options.imagenStatus) {
                    ctx.drawImage(
                      annotation.options.img,
                      model.x1 - sizeImg / 2,
                      model.y1 - 8,
                      sizeImg,
                      sizeImg
                    );
                  }

                  // Dibuja una imagen junto al texto de la anotación
                  const img = new Image();
                  img.src = require("@/assets/icons/companyDefault.png");
                  img.onload = () => {
                    annotation.options.img = img;
                    ctx.drawImage(
                      img,
                      model.x1 - sizeImg / 2,
                      model.y1 - 8,
                      sizeImg,
                      sizeImg
                    ); // Dibuja la imagen en el gráfico
                    annotation.options.imagenStatus = true;
                  };
                }
              );
            },
          },
        ],
      };
    },
    getInfoRange(value, type = "color") {
      const ranges = [
        {
          range: [0, 15], // Es 16 pero se acomoda a 15 para que se pnga en puntos de 5 en 5
          color: "#fda0a0",
          title: "Actuemos ya",
        },
        {
          range: [15, 30],
          color: "#f5bc95",
          title: "Necesita atención pronto",
        },
        { range: [30, 70], color: "#fde8af", title: "Cuidado" },
        { range: [70, 84], color: "#d9ead3", title: "Vamos bien" },
        { range: [84, 100], color: "#76be7c", title: "Sigamos así" },
      ];
      const rangeObject = ranges.find(({ range }) => value < range[1]);
      return rangeObject ? rangeObject[type] : null;
    },
    switchContext() {
      if (this.validCtx) return;
      this.generalContext.status = !this.generalContext.status;
    },
    // Others
    section() {
      this.showSection ? (this.showSection = false) : (this.showSection = true);
    },
    effectNums() {
      /* gsap.to(this, {duration: 1.5, parti: Number(90)}) */
    },
    autoScroll() {
      setTimeout(() => {
        let el = document.getElementById("views");
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    },
    dateProcess(d) {
      let date = new Date(d);
      let options = { year: "numeric", month: "long", day: "numeric" };
      date = date.toLocaleDateString(undefined, options);
      return date;
    },
    processValuesCal(summary) {
      const labelsinicial = Object.keys(summary.total);
      for (let index in labelsinicial) {
        const label = labelsinicial[index];
        summary.total[label].p =
          ((summary.total[label].Alto + summary.total[label]["Muy alto"]) /
            (summary.total[label].Alto +
              summary.total[label]["Muy alto"] +
              summary.total[label].Medio +
              summary.total[label].Bajo +
              summary.total[label]["Muy bajo"])) *
          100;
        summary.total[label].n1 =
          summary.total[label].Alto +
          summary.total[label]["Muy alto"] +
          summary.total[label].Medio +
          summary.total[label].Bajo +
          summary.total[label]["Muy bajo"];
      }
      return summary;
    },
    goToGuie() {
      this.$emit("selectSection", { d: "yGuide", name: "Resultados" });
    },
    getPosition(headers, group) {
      const value = this.summary.total[group].p;
      if (value === null) return "-";
      group = group.toLowerCase();
      const position = headers.ranking[`${group}_p`].filter(
        (item) => item[`${group}_p`] > value
      ).length;
      return position + 1;
    },
    isEmpty(ele) {
      if (ele === undefined) return true;
      if (typeof ele === "object") return Object.keys(ele).length === 0;
      return ele.length === 0;
    },
  },
  mounted() {
    this.autoScroll();
  },
  async created() {
    // this.effectNums();
    await this.findSummary();
    await this.getGeneralContext();
  },
  components: { ResultadosGeneral, ResultadosDetallado },
};
</script>

<style lang="scss" scoped>
.table-radius-6 > tr:last-child {
  border-top-right-radius: 6px !important;
  border-bottom-right-radius: 6px !important;
}

.table-radius-6 > tr:first-child {
  border-top-left-radius: 6px !important;
  border-bottom-left-radius: 6px !important;
}

.table-radius-6 > tr {
  display: flex;
  line-height: 15px;
  font-size: 14px;
}

.table-radius-6 tr > td {
  width: 150px;
  margin: auto;
}

.table-radius-6 tr > div {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.radius-6 {
  border-radius: 6px !important;
}

.section {
  padding: 1rem 1.5rem;
}

.title-card {
  border-radius: 10px !important;
  background-color: #f3f3f3 !important;
}

.title-card .hero-body {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  text-align: center;
}
</style>

<style lang="scss">
.sub-header {
  margin-top: 20px;
  margin-left: 2px;
  margin-right: 2px;
}

.bg-excelente {
  background-color: #76be7c !important;
  color: white;
}

.bg-positivo {
  background-color: #d9ead3 !important;
  color: rgba(65, 64, 64, 0.91);
}

.bg-regular {
  background-color: #fde8af !important;
  color: rgba(65, 64, 64, 0.91);
}

.bg-inconveniente {
  background-color: #f5bc95 !important;
  color: rgba(65, 64, 64, 0.91);
}

.bg-muyinconveniente {
  background-color: #fda0a0 !important;
  color: rgba(65, 64, 64, 0.91);
}

.p-2 {
  padding-left: 0.4rem;
  padding-right: 0.4rem;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
}

.fecha table {
  justify-content: end;
}

.box-sub {
  height: 118px !important;
}

.sub {
  margin-bottom: 6px !important;
}

/* Backgrounds */

.rango1 {
  background-color: #76be7c !important;
  color: white !important;
}

.rango2 {
  background-color: #d9ead3 !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango3 {
  background-color: #fde8af !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango4 {
  background-color: #f5bc95 !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango5 {
  background-color: #fda0a0 !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango0 {
  background-color: rgba(175, 174, 174, 0.8);
}
</style>



// WEBPACK FOOTER //
// src/components/climan/Resultadosclima.vue